import { Box, Flex, Link, Text } from '@applyboard/crystal-ui';
import { useTranslation } from '@applyboard/ui-utils';
import TadaImage from './assets/TadaImage';

const LOANS_HOME_PAGE_URL = 'https://www.applyboard.com/services/student-loan-services';

const Confirmation = () => {
  const { t } = useTranslation();

  return (
    <Flex
      direction="column"
      align="center"
      gap={{
        lg: 12,
        sm: 8,
        xs: 4,
      }}
    >
      <Box pt={32}>
        <TadaImage />
      </Box>
      <Box>
        <Text intent="primary" variant="headlineL" align="center">
          {t('loans.confirmation.confirmationLine')}
        </Text>
      </Box>
      <Box
        pl={{
          xs: 4,
          sm: 8,
          md: 24,
          lg: 28,
          xl: 36,
        }}
        pr={{
          xs: 4,
          sm: 8,
          md: 24,
          lg: 28,
          xl: 36,
        }}
      >
        <Text intent="secondary" variant="bodyS" align="center">
          {t('loans.confirmation.line1')}
        </Text>
        <Text intent="secondary" variant="bodyS" align="center">
          {t('loans.confirmation.line2')}
        </Text>
      </Box>
      <Box>
        <Link href={LOANS_HOME_PAGE_URL} mode="override_user_choice_and_open_in_new_tab">
          <Text intent="secondary" variant="bodyS">
            {t('loans.backToHomepage')}
          </Text>
        </Link>
      </Box>
    </Flex>
  );
};

export default Confirmation;
